<template>
  <a class="float-button">
    <button @click="$emit('click')">
      <slot name="icon" />
      <slot />
    </button>
  </a>
</template>

<script setup></script>

<style scoped lang="postcss">
.float-button {
  @apply rounded-[20px] flex flex-col overflow-hidden;
  /* @apply px-[10.5px] py-[12.83px]; */
  box-shadow: 0px 2px 12px 0px #0000001f;
  @apply <tablet:(w-[68px]);
}
</style>
